export default __webpack_public_path__ + "static/media/google_play.03c2c892.webp";